import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-protection-selector",
  class ProductProtectionSelector extends WYATTElement {
    constructor() {
      super();
      this.toggle = null;
      this.productSelector = null;

      this.addPricesToOptions();
    }

    connectedCallback() {
      const { productSelector, toggleSelector, removeSelector } = this.config;
      if (productSelector && toggleSelector) {
        this.toggle = this.querySelector(toggleSelector);
        this.productSelector = this.querySelector(productSelector);
        this.toggle.addEventListener("change", this.toggleAddon.bind(this));
      }
      if (removeSelector) {
        this.remove = this.querySelector(removeSelector);
        this.remove.addEventListener(
          "click",
          this.disableProductSelect.bind(this),
        );
      }
    }

    addPricesToOptions() {
      const { products } = this.config;
      if (products) {
        products.forEach((product) => {
          const option = this.querySelector(
            `option[value="${product.variantID}"]`,
          );
          if (option) {
            option.textContent = `${product.addonTitle} + ${product.addonMoney}`;
          }
        });
      }
    }

    toggleAddon(event) {
      if (event.target.checked) {
        this.enableProductSelect();
      }
    }

    enableProductSelect() {
      if (this.toggle) {
        this.toggle.checked = true;
      }

      const { productAddonWrapperActive, productAddonWrapper } = this.config;
      if (productAddonWrapperActive && productAddonWrapper) {
        const wrapper = this.querySelector(productAddonWrapper);
        if (wrapper) {
          wrapper.classList.add(productAddonWrapperActive);
        }
        this.productSelector.disabled = false;
      }
    }

    disableProductSelect() {
      if (this.toggle) {
        this.toggle.checked = false;
      }

      const { productAddonWrapperActive, productAddonWrapper } = this.config;
      if (productAddonWrapperActive && productAddonWrapper) {
        const wrapper = this.querySelector(productAddonWrapper);
        if (wrapper) {
          wrapper.classList.remove(productAddonWrapperActive);
        }
        this.productSelector.disabled = true;
      }
    }
  },
);
